import {cutHeadImg} from '@/common/util/global';
let mutations = {
    days21UserInit(state, data) {
        if (data.is_new) {
            state.is_new = data.is_new;
            state.user_state = data.state;
            state.on_training = data.on_training;
        } else {
            // 不是新用户
            state.is_new = false;
            state.user_state = data.state;
            state.on_training = data.on_training;
            state.icon = data.data ? cutHeadImg({
                url: data.data.icon
            }) : '';
            state.nickname = data.data ? data.data.nickname : '';
            state.birthday = data.data ? data.data.birthday : '';
            state.province_id = data.data ? data.data.province_id : '';
            state.province = data.data ? data.data.province : '';
            state.city = data.data ? data.data.city : '';
            state.city_id = data.data ? data.data.city_id : '';
            // 计算age
            // let age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
            let agetemp = (new Date().getTime()/1000 - state.birthday) / (3600 * 24 * 365);
            state.age = Math.floor(agetemp);
            state.remind_time = data.data ? data.data.remind_time : '';
            state.point = data.data ? data.data.point : '';
            state.uid = data.data ? data.data.uid : '';
            state.complete = data.data ? data.data.complete : '';
            //标记数据已经初始化
            state.inited = true;
        }
    },
    days21UserReg(state, data) {
        state.icon = data.icon;
        state.nickname = data.nickname;
        state.birthday = data.birthday;
        // 计算age
        // let age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
        let agetemp = (new Date().getTime()/1000 - state.birthday) / (3600 * 24 * 365);
        state.age = Math.floor(agetemp);
        state.remind_time = data.remind_time;
        state.point = data.point;
    },
    days21UserUpdate(state, data) {
        state.nickname = data.hasOwnProperty('nickname') ? data.nickname : state.nickname;
        state.icon = data.hasOwnProperty('icon') ? data.icon : state.icon;
        state.inited = data.hasOwnProperty('inited') ? data.inited : state.inited;
        state.birthday = data.hasOwnProperty('birthday') ? data.birthday : state.birthday;
        // state.age = new Date().getFullYear() - new Date(state.birthday * 1000).getFullYear();
        let agetemp = (new Date().getTime()/1000 - state.birthday) / (3600 * 24 * 365);
        state.age = Math.floor(agetemp);

        state.remind_time = data.hasOwnProperty('remind_time') ? data.remind_time : state.remind_time;
        state.point = data.hasOwnProperty('point') ? data.point : state.point;
        state.city = data.hasOwnProperty('city') ? data.city : state.city;
        state.city_id = data.hasOwnProperty('city_id') ? data.city_id : state.city_id;
        state.province_id = data.hasOwnProperty('province_id') ? data.province_id : state.province_id;
        state.province = data.hasOwnProperty('province') ? data.province : state.province;
        state.complete = data.hasOwnProperty('complete')? data.complete : '';
    },
}
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/habitUserInfo/mutations.js